import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenCategoriesEpic$ = createListenCollectionEpic({
  collection: 'categories',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenCategoryDetailEpic$ = createListenDocEpic({
  collection: 'categories',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
  ListenCategoriesEpic$,
  ListenCategoryDetailEpic$
};



// WEBPACK FOOTER //
// ./src/categories/epics.ts